import prizeOdds from './prizeOdds';
import wpAjax from '../helpers/axios';

function getWeightedRand(spec) {
	var i,
		sum = 0,
		r = Math.random();

	for (i in spec) {
		sum += spec[i].percentage;
		if (r <= sum) return getPrizeByCode(spec[i].prizeCode);
	}
}

function getPrize() {
	const prizeWeightings = getPrizeWeightings();
	let prize = getWeightedRand(prizeWeightings);

	if (document.getElementById('force_win')) {
		prize = getPrizeByCode(
			document.getElementById('force_win').getAttribute('data-prize-code')
		);
	}

	return prize;
}

function getPrizeWeightings() {
	// Get prize weightings as percentages
	let weightings = prizeOdds
		.filter((prize) => typeof prize.percentage === 'number')
		.map((prize) => {
			return { percentage: prize.percentage, prizeCode: prize.prizeCode };
		});

	// Get remainder as percentage, this is the change the user will not win.
	let remainder =
		1 -
		weightings.reduce(function (sum, item) {
			return sum + item.percentage;
		}, 0);

	if (remainder > 1) {
		console.error(
			'Remainder is too high. An error is likely in the percentages configured in prizeOdds object'
		);
	}
	weightings.push({ percentage: remainder, prizeCode: 'lose' });

	weightings.sort((a, b) => b.percentage - a.percentage);
	const weightingsObj = Object.assign({}, weightings);
	return weightingsObj;
}

function getPrizeByCode(code = false) {
	if (code === false) return false;

	console.log('getprizebycode', code);

	let prize = false;
	prizeOdds.forEach((item) => {
		if (item.prizeCode == code) {
			prize = item;
		}
	});

	return { prize };
}

async function setPrizeWinLoseHtml(prize) {
	const container = document.querySelector('.js-win-lose-content');
	const { data } = await wpAjax.post('', {
		action: 'ajax_get_prize_win_lose_html',
		prize: prize,
	});

	container.innerHTML = data;
}

export { getPrize, setPrizeWinLoseHtml, getPrizeByCode };
